import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://bb725faab6e86c043327b0f283aa49c1@o4508723236241408.ingest.de.sentry.io/4509560140726352',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
